import { Component, ViewChild } from '@angular/core';
import { ICellEditorAngularComp } from '@ag-grid-community/angular';
import { ICellEditorParams } from '@ag-grid-community/core';
import { FormDropdownComponent } from '@cintra-payroll-hr/components';
import type { FormDropdownItem, FormDropdownItemId } from '@cintra-payroll-hr/components';

@Component({
  selector: 'app-dropdown-cell-editor',
  template: `
    <ci-form-dropdown
      [items]="dropdownItems"
      [value]="selectedValue"
      (valueChange)="onValueChange($event)"
      (closed)="onDropdownClosed()"
      [placeholder]="placeholder"
      [hoist]="true"
    ></ci-form-dropdown>
  `,
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
      }

      :host ::ng-deep ci-form-dropdown,
      :host ::ng-deep .form-dropdown,
      :host ::ng-deep .form-dropdown__control {
        width: 100%;
        height: 100%;
      }

      :host ::ng-deep .form-dropdown__trigger {
        border: none;
        background: transparent;
        box-shadow: none;
        padding: 0;
        min-height: unset;
        height: 100%;
        width: 100%;
      }
    `
  ],
  standalone: true,
  imports: [FormDropdownComponent]
})
export class DropdownCellEditorComponent implements ICellEditorAngularComp {
  @ViewChild(FormDropdownComponent) private dropdown!: FormDropdownComponent;

  private params!: ICellEditorParams;
  private valueChanged = false;
  dropdownItems: FormDropdownItem[] = [];
  selectedValue: string = '';
  placeholder: string = 'Select';

  agInit(params: ICellEditorParams): void {
    this.params = params;
    this.selectedValue = params.value != null ? String(params.value) : '';
    this.dropdownItems = (params as any).items ?? [];
    this.placeholder = (params as any).placeholder ?? 'Select';
  }

  afterGuiAttached(): void {
    setTimeout(() => this.dropdown?.isOpen.set(true));
  }

  getValue(): string | null {
    return this.selectedValue || null;
  }

  isPopup(): boolean {
    return false;
  }

  onValueChange(value: FormDropdownItemId | FormDropdownItemId[]): void {
    const id = Array.isArray(value) ? (value[0] ?? '') : value;
    this.selectedValue = String(id);
    this.valueChanged = true;
  }

  onDropdownClosed(): void {
    this.params.stopEditing(!this.valueChanged);
  }
}
